import {useCallback, useRef, useState} from 'react';

import CtrlFView from 'ui-library/CtrlFView';

import {useCtrlFKeydown} from './DOM';

export default function useIsCtrlFOpen(props: {setQuery: (query: string) => void}): {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
} {
  const {setQuery} = props;
  const [isOpen, setOpen] = useState(false);

  const ref = useRef<CtrlFView>(null);
  const onCtrlF = useCallback(
    (newQuery: string | undefined) => {
      setOpen(true);
      if (newQuery) {
        setQuery(newQuery);
      }
      ref.current?.focusAndSelect();
    },
    [setQuery]
  );

  const doClose = useCallback(() => {
    setOpen(false);
  }, []);

  const onCtrlG = useCallback(() => {
    if (!isOpen) {
      setOpen(true);
      ref.current?.focusAndSelect();
    }
  }, [isOpen, setOpen]);

  useCtrlFKeydown(onCtrlF, onCtrlG, doClose);

  return {
    isOpen,
    setOpen,
  };
}
